var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarouselLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn/content.controller copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.000000, -1014.000000)",
    id: "btn/content.controller-copy-8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 1014.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.8,
    fill: "#FFFFFF",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 10.000000)",
    stroke: "#F1BF70",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/content.previous"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    points: "16.3333333 3 7 12.3333333 16.3333333 21.6666667"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselLeft);
export default __webpack_public_path__ + "static/media/carouselLeft.fea1fea98d8e08ae297e1d3ec2ddae8f.svg";
export { ForwardRef as ReactComponent };